import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface Reaction {
  id: string;
  emoji: string;
  x: number;
  timestamp: number;
}

interface FloatingReactionsProps {
  reactions: Reaction[];
}

export default function FloatingReactions({ reactions }: FloatingReactionsProps) {
  const [visibleReactions, setVisibleReactions] = useState<Reaction[]>([]);

  useEffect(() => {
    // Add new reactions to visible list
    reactions.forEach(reaction => {
      if (!visibleReactions.find(r => r.id === reaction.id)) {
        setVisibleReactions(prev => [...prev, reaction]);
        
        // Remove after animation completes
        setTimeout(() => {
          setVisibleReactions(prev => prev.filter(r => r.id !== reaction.id));
        }, 4000);
      }
    });
  }, [reactions]);

  return (
    <div className="fixed inset-0 pointer-events-none z-50">
      <AnimatePresence>
        {visibleReactions.map((reaction) => (
          <motion.div
            key={reaction.id}
            initial={{ 
              y: "100vh", 
              x: `${reaction.x}%`,
              opacity: 1,
              scale: 0.5
            }}
            animate={{ 
              y: "-20vh",
              opacity: 0,
              scale: 1.5
            }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 3,
              ease: "easeOut"
            }}
            className="absolute text-6xl"
            style={{
              left: 0,
              textShadow: "0 2px 8px rgba(0,0,0,0.3)"
            }}
          >
            {reaction.emoji}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
